import React from "react";
import {classNames} from "@ct-react/core";
import {IconHome} from "@tabler/icons-react";
import "./map.scss";

type SearchMarkerProps = { label?: string };

export const SearchMarker = ({ label }: SearchMarkerProps) => (
  <div className={classNames("rsl-map-marker", { "icon": !label })}>
    {!!label ? label : <IconHome />}
  </div>);

export default SearchMarker;
